import { layout } from 'src/styles/layout';
import styled from 'styled-components';
import { palette } from 'src/styles/colors';

export const FooterFormPosition = styled.div`
  justify-self: start;
  align-self: start;
`;

export const FooterFormContainer = styled.div`
  display: grid;
  grid-row-gap: 1.5rem;
  width: 100%;
`;

export const FormInputsContainer = styled.div`
  display: grid;
  grid-row-gap: 0.5rem;

  @media screen and (max-width: ${layout.sm}) {
    .footer-form-title {
      margin-bottom: 1rem;
    }
  }
`;

export const ActionContainer = styled.div`
  display: grid;
  grid-row-gap: 1rem;
  width: 100%;
`;

export const FooterHubspotForm = styled.div`
  position: relative;
  display: grid;
  min-height: 85px;

  .hs-form-required {
    display: none;
  }

  > form {
    fieldset {
      display: grid;
      row-gap: 0.5rem;
      max-width: unset;

      div.legal-consent-container {
        display: none;
      }

      div.hs-form-field {
        width: 100% !important;
        float: none !important;
      }

      legend.hs-field-desc {
        display: none !important;
      }

      div.input {
        width: 100%;
        border-bottom: 1px solid ${palette.white};
        padding-bottom: 5px;
        box-sizing: border-box;

        input {
          text-align: left;
          font-size: 1rem;
          width: 100%;
          height: 100%;
          border: 0;
          box-sizing: border-box;
          color: ${palette.white};
          background: transparent;
          min-height: 33px;

          &:focus {
            outline: none;
          }

          &::placeholder {
            opacity: 0.5;
            font-weight: 700;
          }
        }
      }
    }

    .hs-error-msgs {
      color: ${palette.softErrorRed};
      margin: 0.25rem;
      font-size: 0.75rem;
      padding-left: 0rem;
      list-style: none;
    }

    input[type='submit'] {
      display: none;
    }
  }
`;
